// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"153":"4700663e","169":"4700663e","873":"f0716b77"}[chunkId] + ".chunk.css";
};